import { resolveComponent as _resolveComponent, vShow as _vShow, createVNode as _createVNode, withDirectives as _withDirectives, mergeProps as _mergeProps, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_badge = _resolveComponent("q-badge")!
  const _component_q_btn = _resolveComponent("q-btn")!

  return (_ctx.isGranted('VIEW_POST_NOTES'))
    ? (_openBlock(), _createBlock(_component_q_btn, _mergeProps({
        key: 0,
        icon: "fa fa-comment-dots",
        title: _ctx.title
      }, _ctx.$attrs, { onClick: _ctx.openModal }), {
        default: _withCtx(() => [
          _withDirectives(_createVNode(_component_q_badge, {
            label: _ctx.post.totalNotes,
            color: "primary",
            outline: "",
            floating: "",
            style: {"top":"-1px"}
          }, null, 8, ["label"]), [
            [_vShow, _ctx.post.totalNotes]
          ])
        ]),
        _: 1
      }, 16, ["title", "onClick"]))
    : _createCommentVNode("", true)
}